/* Cart add-ons (owner, 20 October 2026): Shipping Protection as a tick box just above Checkout on the cart page and in
 * the mini cart, in the shop's look (LOP sky blue, BLP honey). Each add-on is an Unlisted
 * Shopify product that needs no shipping (packages/domain/src/cart-addons.ts, created per shop by
 * scripts/storefront-experience/cart-addon-products.mjs). Ticking adds one of it to the cart; unticking removes it. The
 * boxes show while the cart holds an item that ships; a cart without one loses its add-ons, and an add-on never stays at
 * more than one. Prices are the shop's own for the shopper's market (`/products/<handle>.js`); the waived reshipping fee
 * in a description is converted at Shopify's rate for that market. A shop without the
 * products shows nothing. Installed by `theme.mjs prepare-cart-addons`, which writes ADDONS from @svspe/domain and the
 * layout's script tag with the shop's style. The boxes have no form field name, so they never travel with the cart form.
 * Since the cart redesign (20 October 2026): on the cart page the box sits on top of the Buyer Protection card
 * (`.cart-assurance`); add-ons never show as cart lines; and the header's `.cart_count` counts products only.
 * Pre-selected add-ons (`preselectExcept`, owner 20 October 2026) are added once to a cart that ships, so they show
 * ticked, except for the listed market countries (UK, EU) or an unknown country. Unticking sets the cart attribute
 * `_svs_declined_<key>`, so that cart never gets it added again.
 * Product add-ons (the gift box, owner 31 October 2026) are ticked on the product page and show as ordinary cart lines.
 * Each names its design's line in GIFT_BOX_PROPERTY; here it keeps that line's quantity and leaves with it. */
(function(){
  'use strict';
  var GIFT_BOX_PROPERTY='_svs_gift_box_for';
  var ADDONS=[{"key":"protection","handle":"svs-shipping-protection","title":"Shipping Protection","description":"Wrong address or a delivery problem? We reship your order free, saving you the {fee} reshipping fee.","waivedFee":9.99,"preselectExcept":["GB","AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","IS","LI","NO"]}];
  // Add-ons show as their tick box, never as lines in the cart page or mini cart (which the theme redraws itself).
  (function(){
    var css=ADDONS.map(function(addon){var link='a[href*="/products/'+addon.handle+'"]';return '#cart_form .cart__item:has('+link+'),.mini-cart__item:has('+link+')';}).join(',');
    var tag=document.createElement('style');tag.id='svs-ca-lines';tag.textContent=css+'{display:none!important}';document.head.appendChild(tag);
  })();
  var script=document.currentScript;
  var style=script&&script.getAttribute('data-svs-style')==='BLP'?'BLP':'LOP';
  // Liquid's item count: an empty cart needs no read until something is added.
  var initial=Number(script&&script.getAttribute('data-svs-items'));
  var WORDS={
    de:{'Shipping Protection':'Versandschutz','Wrong address or a delivery problem? We reship your order free, saving you the {fee} reshipping fee.':'Falsche Adresse oder ein Zustellproblem? Wir versenden Ihre Bestellung kostenlos erneut und Sie sparen die Gebühr von {fee}.'},
    fr:{'Shipping Protection':'Protection de livraison','Wrong address or a delivery problem? We reship your order free, saving you the {fee} reshipping fee.':'Mauvaise adresse ou problème de livraison ? Nous réexpédions votre commande gratuitement : vous économisez les {fee} de frais de réexpédition.'}};
  var lang=(document.documentElement.lang||'en').slice(0,2).toLowerCase();
  function t(english){return (WORDS[lang]&&WORDS[lang][english])||english;}
  function esc(value){return String(value).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function root(){var path=window.Shopify&&Shopify.routes&&Shopify.routes.root||'/';return /^\/(?!\/)[A-Za-z0-9_/-]*\/$/.test(path)?path:'/';}
  function country(){return String(window.Shopify&&Shopify.country||'').toUpperCase();}
  var DECLINED='_svs_declined_',autoTried={};
  function preselected(key){
    var addon=ADDONS.filter(function(a){return a.key===key;})[0],code=country();
    return !!(addon&&addon.preselectExcept&&/^[A-Z]{2}$/.test(code)&&addon.preselectExcept.indexOf(code)<0);
  }
  function currency(){return String(window.Shopify&&Shopify.currency&&Shopify.currency.active||'USD').toUpperCase();}
  function money(cents){
    var value=cents/100,code=currency();
    try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency:code,minimumFractionDigits:2,maximumFractionDigits:2}).format(value);}
    catch{return value.toFixed(2)+' '+code;}
  }
  // A shop-currency amount in the shopper's currency at Shopify's rate for the market.
  function converted(amount){var rate=Number(window.Shopify&&Shopify.currency&&Shopify.currency.rate);return money(Math.round(amount*100*(rate>0?rate:1)));}
  function describe(addon){var words=t(addon.description);return addon.waivedFee?words.replace('{fee}',converted(addon.waivedFee)):words;}
  function post(path,body){
    return fetch(root()+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.ok?r.json():Promise.reject(r.status);});
  }

  var CSS='.svs-ca{--a-text:#2b2a2a;--a-muted:#8c8b8b;--a-accent:#ff8a29;--a-tick:#49b7ff;--a-border:#e3e8ee;box-sizing:border-box;display:block;width:100%;flex:0 0 100%;margin:0 0 12px;padding:4px 12px;border:1px solid var(--a-border);border-radius:12px;background:#fff;color:var(--a-text);font-family:inherit;font-size:13px;line-height:1.35;text-align:left}'+
    '.svs-ca *{box-sizing:border-box}'+
    '.svs-ca--BLP{--a-text:#333;--a-muted:#7a7569;--a-accent:#a8730c;--a-tick:#eaa92a;--a-border:#ebe3d3}'+
    '.svs-ca label.svs-ca__row{display:block;margin:0;padding:10px 0;cursor:pointer;color:inherit;font-size:13px;font-weight:400;text-transform:none;letter-spacing:0}'+
    '.svs-ca label.svs-ca__row+label.svs-ca__row{border-top:1px solid var(--a-border)}'+
    '.svs-ca .svs-ca__head{display:flex;align-items:center;gap:8px;font-size:15px;line-height:1.3;font-weight:600}'+
    '.svs-ca input.svs-ca__tick{flex:none;width:16px;height:16px;min-height:0;margin:0;padding:0;accent-color:var(--a-tick);cursor:pointer}'+
    '.svs-ca .svs-ca__title{flex:1;min-width:0}'+
    '.svs-ca .svs-ca__price{color:var(--a-accent);font-weight:700;white-space:nowrap}'+
    '.svs-ca .svs-ca__desc{display:block;margin:4px 0 0;color:var(--a-muted);font-size:12px;font-weight:400}'+
    '.svs-ca--mini{margin:0 0 10px;padding:2px 10px}.svs-ca--mini label.svs-ca__row{padding:8px 0}.svs-ca--mini .svs-ca__head{font-size:14px}'+
    '.svs-ca--mini input.svs-ca__tick{width:15px;height:15px}.svs-ca--mini .svs-ca__desc{font-size:11px}';

  function isAddon(item){for(var i=0;i<ADDONS.length;i++)if(ADDONS[i].handle===item.handle)return true;return false;}
  // Each add-on's single variant in this market, read at most every ten minutes per visit. A shop without the product
  // (404) leaves that add-on out; a failed read is tried again on the next cart change.
  var products=null;
  function loadProducts(){
    if(products)return products;
    var key='svs-ca:'+root()+':'+currency(),saved=null;
    try{saved=JSON.parse(sessionStorage.getItem(key)||'null');}catch{}
    if(saved&&saved.until>Date.now()&&Array.isArray(saved.list))return products=Promise.resolve(saved.list);
    var failed=false;
    return products=Promise.all(ADDONS.map(function(addon){
      return fetch(root()+'products/'+encodeURIComponent(addon.handle)+'.js',{credentials:'same-origin'})
        .then(function(r){if(r.status===404)return null;return r.ok?r.json():Promise.reject(r.status);})
        .then(function(product){
          var variant=product&&product.variants&&product.variants.length===1?product.variants[0]:null;
          return variant&&variant.available!==false&&isFinite(variant.price)?{key:addon.key,handle:addon.handle,title:addon.title,description:addon.description,waivedFee:addon.waivedFee,variant:variant.id,price:variant.price}:null;
        },function(){failed=true;return null;});
    })).then(function(list){
      list=list.filter(Boolean);
      if(failed)products=null;else try{sessionStorage.setItem(key,JSON.stringify({until:Date.now()+600000,list:list}));}catch{}
      return list;
    });
  }

  function markup(list,items,layout){
    var html='<div class="svs-ca svs-ca--'+style+' svs-ca--'+layout+'">';
    list.forEach(function(addon){
      var on=items.some(function(item){return item.handle===addon.handle&&item.quantity>0;});
      // Tick box, headline and price on one row; the description runs the full width underneath.
      html+='<label class="svs-ca__row"><span class="svs-ca__head"><input class="svs-ca__tick" type="checkbox" data-svs-ca-key="'+esc(addon.key)+'"'+(on?' checked':'')+'>'+
        '<span class="svs-ca__title">'+esc(t(addon.title))+'</span><span class="svs-ca__price">'+esc(money(addon.price))+'</span></span>'+
        '<span class="svs-ca__desc">'+esc(describe(addon))+'</span></label>';
    });
    return html+'</div>';
  }
  function forms(){
    var list=[];
    document.querySelectorAll('form[data-cart-form="cart-template"],form[data-cart-form="mini-cart"]').forEach(function(form){list.push(form);});
    return list;
  }
  // On top of the cart page's Buyer Protection card; otherwise just above Checkout, or at the form's end.
  var shown=null,lastItems=[];
  function render(list,items){
    shown=list;lastItems=items;
    if(list&&list.length&&!document.getElementById('svs-ca-style')){
      var sheet=document.createElement('style');sheet.id='svs-ca-style';sheet.textContent=CSS;document.head.appendChild(sheet);
    }
    forms().forEach(function(form){
      var box=form.querySelector('[data-svs-ca]');
      if(!list||!list.length){if(box)box.remove();return;}
      if(!box){
        box=document.createElement('div');box.setAttribute('data-svs-ca','');
        var anchor=form.querySelector('.cart-assurance')||form.querySelector('[name="checkout"]');
        if(anchor)anchor.parentNode.insertBefore(box,anchor);else form.appendChild(box);
      }
      box.innerHTML=markup(list,items,form.getAttribute('data-cart-form')==='mini-cart'?'mini':'page');
    });
  }

  var cartPage=function(){return !!document.querySelector('form[data-cart-form="cart-template"]');};
  // The cart page shows the change by reloading, as the upsell runtime does; the mini cart redraws from svs:cart-updated.
  function changed(){
    if(cartPage()){location.reload();return;}
    window.dispatchEvent(new CustomEvent('svs:cart-updated'));later();
  }
  var latest=0,streak=0;
  function refresh(){
    var current=++latest;
    fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store'})
      .then(function(r){return r.ok?r.json():Promise.reject(r.status);})
      .then(function(cart){
        if(current!==latest)return;
        var items=(cart.items||[]).filter(function(item){return item.quantity>0;});
        var ships=items.some(function(item){return item.requires_shipping!==false&&!isAddon(item);});
        // The header count is products only; the theme writes Shopify's count, which includes add-ons.
        var productCount=0;items.forEach(function(item){if(!isAddon(item))productCount+=item.quantity;});
        document.querySelectorAll('.cart_count').forEach(function(el){if(el.textContent.trim()!==String(productCount))el.textContent=String(productCount);});
        // No add-on without an item that ships, and at most one of each.
        var updates={},count=0,seen={};
        // A product add-on line keeps its design's quantity: one gift box per dish, none once the dish has gone.
        var designs={};
        items.forEach(function(item){var p=item.properties||{};if(p._svs_personalization&&p._svs_upsell!=='1'&&!p[GIFT_BOX_PROPERTY])designs[p._svs_personalization]=(designs[p._svs_personalization]||0)+item.quantity;});
        items.forEach(function(item){
          var parent=(item.properties||{})[GIFT_BOX_PROPERTY];
          if(parent){var target=designs[parent]||0;if(item.quantity!==target){updates[item.key]=target;count++;}return;}
          if(!isAddon(item))return;
          var keep=ships&&!seen[item.handle]?1:0;seen[item.handle]=true;
          if(item.quantity!==keep){updates[item.key]=keep;count++;}
        });
        if(count&&streak<3){streak++;return post('cart/update.js',{updates:updates}).then(changed);}
        streak=0;
        if(!ships){render(null,items);return;}
        var attributes=cart.attributes||{};
        return loadProducts().then(function(list){
          if(current!==latest)return;
          // Pre-selected add-ons: added once to a cart that ships, unless the shopper unticked them in this cart.
          var add=list.filter(function(addon){
            return preselected(addon.key)&&!autoTried[addon.key]&&!attributes[DECLINED+addon.key]&&!items.some(function(item){return item.handle===addon.handle;});
          });
          if(!add.length){render(list,items);return;}
          add.forEach(function(addon){autoTried[addon.key]=true;});
          return post('cart/add.js',{items:add.map(function(addon){return {id:addon.variant,quantity:1};})}).then(changed,function(){render(list,items);});
        });
      })
      .catch(function(){/* The cart stays as it is; the next cart change reads it again. */});
  }
  var timer=0;
  function later(){clearTimeout(timer);timer=setTimeout(refresh,150);}

  document.addEventListener('change',function(event){
    var input=event.target;
    if(!input||!input.matches||!input.matches('input[data-svs-ca-key]'))return;
    var addon=(shown||[]).filter(function(a){return a.key===input.getAttribute('data-svs-ca-key');})[0];
    if(!addon)return;
    var line=lastItems.filter(function(item){return item.handle===addon.handle;})[0];
    document.querySelectorAll('input[data-svs-ca-key]').forEach(function(box){box.disabled=true;});
    // Unticking remembers the choice on the cart, so a pre-selected add-on is not added back; ticking clears it.
    var remember={};remember[DECLINED+addon.key]=input.checked?'':'1';
    var request=input.checked?(line?Promise.resolve():post('cart/add.js',{items:[{id:addon.variant,quantity:1}]})).then(function(){return post('cart/update.js',{attributes:remember});}):
      (function(){var updates={};if(line)updates[line.key]=0;return post('cart/update.js',{updates:updates,attributes:remember});})();
    request.then(changed,function(){input.checked=!input.checked;later();});
  });

  if(forms().length&&!(initial===0))refresh();
  document.querySelectorAll('.js-cart_items').forEach(function(list){new MutationObserver(later).observe(list,{childList:true});});
  window.addEventListener('svs:cart-updated',later);
  window.addEventListener('pageshow',function(event){if(event.persisted)refresh();});
})();
